import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import i18n from "../i18n/i18n";

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("PageErrorBoundary caught an error:", error);
    console.error("Component stack:", errorInfo?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            padding: 3,
          }}
        >
          <ErrorOutlineIcon
            sx={{ fontSize: 60, color: "error.main", mb: 2 }}
          />
          <Typography variant="h6" gutterBottom>
            {i18n.t('errors.pageError')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {i18n.t('errors.pleaseRefresh')}
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={this.handleReload}
          >
            {i18n.t('errors.pleaseRefresh')}
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default PageErrorBoundary;
